const columns = [
  { column: 'contract_charge', id: 1, w: 'w150', label: 'Freight', readonly: false },
  { column: 'transit_charge', id: 2, w: 'w150', label: 'Delay', readonly: true },
  { column: 'loading_charge', id: 3, w: 'w150', label: 'Loading', readonly: false },
  { column: 'unloading_charge', id: 4, w: 'w150', label: 'Unloading', readonly: false },
  { column: 'loading_detention_charge', id: 5, w: 'w200', label: 'Loading Detention', readonly: false },
  { column: 'unloading_detention_charge', id: 6, w: 'w150', label: 'UnLoading Detention', readonly: false },
  { column: 'arrival_charge', id: 7, w: 'w150', label: 'Penalty', readonly: true },
  { column: 'lr_charge', id: 8, w: 'w100', label: 'LR', readonly: false },
  { column: 'additional_point_charges', id: 9, w: 'w150', label: 'Additional Point', readonly: false },
  { column: 'oda_charges', id: 10, w: 'w150', label: 'ODA', readonly: false },
  { column: 'extra_charges', id: 11, w: 'w150', label: 'Miscellaneous charge', comments: true, readonly: false },
  { column: 'shortage_charge', id: 12, w: 'w150', label: 'Shortage', readonly: true },
  { column: 'damage_charge', id: 13, w: 'w150', label: 'Damage', readonly: true },
  { column: 'leakage_charge', id: 14, w: 'w150', label: 'Leakage', readonly: true },
  { column: 'carton_damage_charge', id: 15, w: 'w150', label: 'Carton Damage', readonly: true },
  { column: 'wallet_penalty_charge', id: 16, w: 'w150', label: 'SLA Delay', readonly: false },
  // { column: 'total_amount', id: 17, w: 'w200', readonly: true, label: 'Total', fixed: 'right' },
];

export default columns;
